const NBSP = ' ';

const LETTER = 'A-Za-zÀ-ÖØ-öø-ÿŒœ';
const APOSTROPHE = new RegExp(`([${LETTER}])'([${LETTER}])`, 'g');

/**
 * French typography: non-breaking space before high punctuation (? ! : ; ») and
 * after an opening guillemet, typographic apostrophe between letters. URLs are
 * untouched (no space before their colon, no apostrophe).
 */
export function fr(text: string): string {
	return text
		.replace(/ ([?!:;»])/g, `${NBSP}$1`)
		.replace(/« /g, `«${NBSP}`)
		.replace(APOSTROPHE, '$1’$2');
}

/** Apply fr() to every string of a nested content object. */
export function frDeep<T>(value: T): T {
	if (typeof value === 'string') return fr(value) as unknown as T;
	if (Array.isArray(value)) return value.map((item) => frDeep(item)) as unknown as T;
	if (value && typeof value === 'object') {
		const out: Record<string, unknown> = {};
		for (const [key, item] of Object.entries(value as Record<string, unknown>)) out[key] = frDeep(item);
		return out as T;
	}
	return value;
}
